export default __webpack_public_path__ + "static/media/com_logo.e479ccf3.png";